import { TechMeansWithRecommend } from './common.interface';

export interface ApiPutTechMeansRequest {
    task_id: string;
    current_step: string;
    tech_means: string;
}

export type ApiPutTechMeansResponse = TechMeansWithRecommend;

export const PutTechMeans = Symbol('PutTechMeans');

export interface PutTechMeans {
    putTechMeans(data: ApiPutTechMeansRequest): Promise<ApiPutTechMeansResponse>;
}
